import React, { useEffect, useState, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Paper, useTheme, useMediaQuery, Typography } from "@mui/material";
import { fetchPlaylistCalls } from "../../store/Playlists/playlistsThunks";
// import RecordedCallDataGrid from "../RecordedCall/Components/RecordedCallDataGrid/RecordedCallDataGrid";
import PageTitle from "../../components/PageTitle";
// import CustomPlaylistCallsToolbar from "./Components/PlaylistsCalls/CustomPlaylistCallsToolbar";
import CustomToolbar from "./Components/PlaylistsCalls/CustomPlaylistCallsToolbar";
import PlaylistRecordedCallDataGrid from "./Components/PlaylistRecordedCallDataGrid/PlaylistRecordedCallDataGrid";

const PlaylistRecordedCalls = () => {
  const { playlistId } = useParams();
  const location = useLocation();
  const playlistName = location.state?.name;
  const dispatch = useDispatch();
  const calls = useSelector((state) => state.playlists.playlistCalls);
  const loading = useSelector((state) => state.playlists.playlistCallsLoading);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const gridApiRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (playlistId) {
      dispatch(fetchPlaylistCalls({ playlistId }));
    }
  }, [playlistId, dispatch]);

  const handleSearch = (query) => {
    setSearchQuery(query);
    dispatch(fetchPlaylistCalls({ playlistId, search: query }));
  };

  const handleRefresh = () => {
    dispatch(fetchPlaylistCalls({ playlistId, search: searchQuery }));
  };

  const handleFilterClick = () => {
    if (gridApiRef.current) gridApiRef.current.showFilterPanel();
  };

  const handleColumnClick = () => {
    if (gridApiRef.current) gridApiRef.current.showPreferences("columns");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        maxHeight: "100vh",
        overflow: "hidden",
        backgroundColor: (theme) => theme.palette.grey[50],
      }}
    >
      {/* Header section */}
      <Box
        sx={{
          backgroundColor: (theme) => theme.palette.background.paper,
          p: isSmallScreen ? 1 : 2,
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            alignItems: isSmallScreen ? "flex-start" : "center",
            justifyContent: "space-between",
            gap: isSmallScreen ? 2 : 0,
          }}
        >
          <PageTitle
            title={playlistName || `Playlist ${playlistId}`}
            subtitle="Review calls within this playlist"
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: isSmallScreen ? "column" : "row",
              alignItems: isSmallScreen ? "stretch" : "center",
              gap: 2,
              width: isSmallScreen ? "100%" : "auto",
            }}
          >
            <CustomToolbar
              onSearch={handleSearch}
              searchQuery={searchQuery}
              onRefresh={handleRefresh}
              onFilterClick={handleFilterClick}
              onColumnClick={handleColumnClick}
              isSmallScreen={isSmallScreen}
            />
          </Box>
        </Box>
      </Box>

      {/* Data grid section */}
      <Box
        sx={{
          flex: 1,
          overflow: "hidden",
          position: "relative",
          height: "calc(100vh - 120px)",
        }}
      >
        <Paper
          elevation={0}
          
          sx={{
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            overflow: "auto",
            borderRadius: 0,
            "& .MuiDataGrid-root": {
              border: "none",
              backgroundColor: (theme) => theme.palette.background.paper,
              padding: 0,
              margin: 0,
            },
          }}
        >
          {Array.isArray(calls) && calls.length > 0 ? (
            <PlaylistRecordedCallDataGrid
              playlistId={playlistId}
              data={calls}
              loading={loading}
              searchQuery={searchQuery}
              onSearch={handleSearch}
              apiRef={gridApiRef}
            />
          ) : (
            <Box sx={{ p: 3 }}>
              <Typography variant="body1">
                No calls found in this playlist.
              </Typography>
            </Box>
          )}
        </Paper>
      </Box>
    </Box>
  );
};

export default PlaylistRecordedCalls;
